import { Descendant, Text } from "slate";

import { TEAM_MENTION_PREFIX } from "@mapmycustomers/shared/util/consts/mentions";

import ElementType from "../../../../../type/slate/ElementType";

const convertToTextWithMentions = (value: Descendant[]): string =>
  value
    .map((element) =>
      "text" in element
        ? element.text
        : element.children
            .map((child: Descendant) => {
              if ("text" in child) {
                return (child as Text).text;
              } else if (child.type === ElementType.MENTION) {
                return child.email
                  ? `@${child.email}`
                  : child.teamId
                    ? `${TEAM_MENTION_PREFIX}${child.teamId}`
                    : "";
              } else {
                return "";
              }
            })
            .join("")
    )
    .join("\n");

export default convertToTextWithMentions;
